export default __webpack_public_path__ + "static/media/2059.8fbfd0d8.png";